import { useEffect, useRef, useState } from 'react'

import Btn from '../../../../UI/Btn'
import Loading from '../../../../UI/Loading'

import http from '../../../../shared/http'
import { TApi } from '../../../../shared/const'
import { errorText } from '../../../../shared/errorMessage'

import styles from './style.module.scss'

/**
 * Die Junior-Bilanz eines Schuljahrs.
 *
 * Der Bericht ist ein fertiges Dokument mit eigener Gestaltung und eigener
 * Druckansicht. Er wird deshalb nicht nachgebaut, sondern in einem Rahmen
 * angezeigt — so bleibt sein Aussehen von der Anwendung unberührt, und die
 * Anwendung von seinem. Beides, Seite und PDF, kommt aus derselben Datei im
 * Backend.
 *
 * Geholt wird der Bericht mit dem angemeldeten Zugang und daraus eine
 * Objektadresse gemacht. Eine Adresse direkt in den Rahmen zu schreiben ginge
 * nicht: Der Rahmen lädt ohne Anmeldung und bekäme 401.
 */
export default function AnnualReport() {
	const [quelle, setQuelle] = useState(null)
	const [fehler, setFehler] = useState(null)
	const [ladeVorgang, setLadeVorgang] = useState(true)
	const [pdfLaeuft, setPdfLaeuft] = useState(false)

	// Die Objektadresse gehört wieder freigegeben, sonst bleibt der Bericht im
	// Speicher des Browsers liegen — bei über zwei Megabyte fällt das auf.
	const adresse = useRef(null)

	useEffect(() => {
		let abgemeldet = false

		http.get(TApi.ADMIN_ANNUAL_REPORT, { responseType: 'blob', disableToast: true })
			.then(({ data }) => {
				if (abgemeldet) return
				adresse.current = window.URL.createObjectURL(new Blob([data], { type: 'text/html' }))
				setQuelle(adresse.current)
			})
			.catch(error => !abgemeldet && setFehler(errorText(error)))
			.finally(() => !abgemeldet && setLadeVorgang(false))

		return () => {
			abgemeldet = true
			if (adresse.current) window.URL.revokeObjectURL(adresse.current)
		}
	}, [])

	const ladePdf = () => {
		setPdfLaeuft(true)

		http.get(TApi.ADMIN_ANNUAL_REPORT_PDF, { responseType: 'blob', disableToast: true })
			.then(({ data }) => {
				const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', 'Junior-Bilanz-2025-26.pdf')
				document.body.appendChild(link)
				link.click()
				link.parentNode.removeChild(link)
				window.URL.revokeObjectURL(url)
			})
			.catch(error => setFehler(errorText(error)))
			.finally(() => setPdfLaeuft(false))
	}

	return (
		<div className={styles.root}>
			<div className={styles.head}>
				<div>
					<h1 className={styles.title}>Junior-Bilanz 2025/26</h1>
					<p className={styles.sub}>
						Noch nicht im Menü verlinkt — die Seite ist zur Abstimmung mit Junior Achievement gedacht und
						nur über diese Adresse erreichbar.
					</p>
				</div>
				<Btn theme="grey" onClick={ladePdf} loading={pdfLaeuft} disabled={!quelle}>
					PDF herunterladen
				</Btn>
			</div>

			{/*
			 * Das PDF entsteht erst beim Abruf und braucht dafür ein paar
			 * Sekunden. Ohne Hinweis sieht ein Knopf, der nichts tut, nach
			 * einem Fehler aus.
			 */}
			{pdfLaeuft && <p className={styles.hinweis}>Das PDF wird erzeugt, das dauert einen Moment …</p>}

			{fehler && <p className={styles.fehler}>{fehler}</p>}

			{ladeVorgang && <Loading />}

			{quelle && <iframe className={styles.rahmen} src={quelle} title="Junior-Bilanz 2025/26" />}
		</div>
	)
}
